export const DownArrowIcon = () => {
    return (<svg
        xmlns="http://www.w3.org/2000/svg"
        width={8}
        height={6}
        viewBox="0 0 8 6"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.20711 1.68758L6.5 0.980469L3.85355 3.62692L1.20711 0.980469L0.5 1.68758L3.85355 5.04113L7.20711 1.68758Z"
            fill="#FCFCFC"
            fillOpacity="0.4"
        />
    </svg>);
};
